class CartDiscounts {
  constructor() {
    this.footer = document.querySelector('.cart-drawer__footer');
    this.form = document.querySelector('.custom-discount-form .form');
    this.input = document.querySelector('.custom-discount-form input[name="custom-discount-input"]');
    this.submitButton = document.querySelector('.custom-discount-form .submit-discount');
    this.errorEl = document.querySelector('.custom-discount-form p.error');
    this.list = document.querySelector('.cart_discounts');
    this.totalEls = Array.from(document.querySelectorAll('.cart-drawer__footer [data-cart-total], .cart-drawer__footer .totals__total-value, .cart-drawer__footer .price--end'));
    this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    this.svgDiscount = '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M21 13.59 13.59 21a2 2 0 0 1-2.83 0L3 13.24V3h10.24l7.76 7.76a2 2 0 0 1 0 2.83ZM7 7.75A1.75 1.75 0 1 0 7 4.25a1.75 1.75 0 0 0 0 3.5Z"/></svg>';
    this.svgClose = '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 1 0-1.41 1.42L10.59 12l-4.9 4.89a1 1 0 1 0 1.41 1.42L12 13.41l4.89 4.9a1 1 0 0 0 1.42-1.41L13.41 12l4.9-4.89a1 1 0 0 0-.01-1.4Z"/></svg>';
    if (this.submitButton) this.submitButton.setAttribute('type', 'button');
    this.bindGuards();
    this.bindEvents();
    this.refreshUI();
  }

  bindGuards() {
    document.addEventListener('submit', e => {
      if (e.target && (e.target.closest('.custom-discount-form') || e.target.closest('.cart-drawer__footer'))) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }, true);
    document.addEventListener('keydown', e => {
      if (e.key === 'Enter' && e.target && e.target.closest('.custom-discount-form')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }, true);
  }

  bindEvents() {
    document.addEventListener('click', async (e) => {
      if (this._busy) return;

      const submitBtn = e.target.closest('.custom-discount-form .submit-discount');
      if (submitBtn) {
        e.preventDefault();
        e.stopPropagation();
        this.hideError();

        const inputEl = document.querySelector('.custom-discount-form input[name="custom-discount-input"]');
        const newCode = (inputEl && inputEl.value || '').trim();
        if (!newCode) { this.showError('Enter a valid discount code or gift card'); return; }

        this._busy = true;
        this.setLoading(true, submitBtn);
        try {
          const current = Array.from(document.querySelectorAll('.remove-discount'))
            .map(b => b.dataset.code)
            .filter(Boolean);
          if (!current.includes(newCode)) current.push(newCode);

          await this.applyDiscounts(current);
          await this.refreshUI();

          const exists = Array.from(document.querySelectorAll('.remove-discount'))
            .some(b => b.dataset.code === newCode);
          if (!exists) {
            this.showError('Enter a valid discount code or gift card');
          } else if (inputEl) {
            inputEl.value = '';
          }
        } catch (err) {
          console.error(err);
          this.showError('Something went wrong applying the code. Please try again.');
        } finally {
          this.setLoading(false, submitBtn);
          this._busy = false;
        }
        return;
      }

      const removeBtn = e.target.closest('.cart_discounts .remove-discount');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();

        const submitBtnRef = document.querySelector('.custom-discount-form .submit-discount');

        this._busy = true;
        this.setLoading(true, submitBtnRef);
        try {
          const current = Array.from(document.querySelectorAll('.remove-discount'))
            .map(b => b.dataset.code)
            .filter(Boolean);
          const remain = current.filter(c => c !== removeBtn.dataset.code);

          await this.applyDiscounts(remain);
          await this.refreshUI();
        } catch (err) {
          console.error(err);
          this.showError('Could not remove the discount. Please try again.');
        } finally {
          this.setLoading(false, submitBtnRef);
          this._busy = false;
        }
      }
    }, true);
  }

  cartGet() {
    return fetch(this.root + 'cart.js', { credentials: 'include' }).then(r => r.json());
  }

  cartUpdate(payload) {
    return fetch(this.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload || {})
    }).then(r => r.json());
  }

  applyDiscounts(codes) {
    const codeStr = (codes || []).map(s => String(s).trim()).filter(Boolean).join(',');
    return this.cartUpdate({ discount: codeStr });
  }

  money(cents) {
    try {
      return (cents/100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (_) {
      return (cents/100).toFixed(2);
    }
  }

  escapeHtml(s) {
    return String(s)
      .replaceAll('&','&amp;')
      .replaceAll('<','&lt;')
      .replaceAll('>','&gt;')
      .replaceAll('"','&quot;')
      .replaceAll("'",'&#39;');
  }

  ensureTopList() {
    if (!this.footer) return { topBlock:null, topList:null };
    let topBlock = this.footer.querySelector('[data-top-discounts-block]') || this.footer.children[0];
    if (!topBlock || topBlock.tagName !== 'DIV') {
      topBlock = document.createElement('div');
      this.footer.insertBefore(topBlock, this.footer.firstChild || null);
    }
    topBlock.setAttribute('data-top-discounts-block', '');
    let topList = topBlock.querySelector('ul.discounts.list-unstyled:not(.cart_discounts)');
    if (!topList) {
      topList = document.createElement('ul');
      topList.className = 'discounts list-unstyled';
      topBlock.appendChild(topList);
    }
    return { topBlock, topList };
  }

  extractDiscountsFromCart(cart) {
    const all = new Set();
    const codeOnly = new Set();
    (cart.cart_level_discount_applications || []).forEach(d => {
      all.add(d.title);
      if (d.type === 'discount_code') codeOnly.add(d.title);
    });
    (cart.items || []).forEach(item => {
      (item.line_level_discount_allocations || []).forEach(alloc => {
        const t = alloc && alloc.discount_application && alloc.discount_application.title;
        if (t) {
          all.add(t);
          if (alloc.discount_application.type === 'discount_code') codeOnly.add(t);
        }
      });
    });
    return { allCodes: Array.from(all), codeCodes: Array.from(codeOnly) };
  }

  renderTopDiscounts(cart) {
    const { topBlock, topList } = this.ensureTopList();
    if (!topBlock || !topList) return;
    const apps = cart.cart_level_discount_applications || [];
    if (!apps.length) {
      topList.innerHTML = '';
      topBlock.style.display = 'none';
      return;
    }
    topBlock.style.display = '';
    topList.innerHTML = apps.map(d => {
      const title = this.escapeHtml(d.title || '');
      const hasAmount = typeof d.total_allocated_amount === 'number';
      const amount = hasAmount ? this.money(d.total_allocated_amount) : '';
      return `
        <li class="discounts__discount discounts__discount--end">
          <span>${title}</span>
          ${hasAmount ? `<span>(-${this.escapeHtml(amount)})</span>` : ''}
        </li>
      `;
    }).join('');
  }

  renderBottomList(allCodes, codeCodes) {
    if (!this.list) return;
    if (!allCodes.length) { this.list.innerHTML = ''; return; }
    this.list.innerHTML = allCodes.map(code => {
      const removable = codeCodes.includes(code);
      return `
        <li class="discounts__discount discounts__discount--position">
          <span class="icon icon-discount" aria-hidden="true">${this.svgDiscount}</span>
          <span>${this.escapeHtml(code)}</span>
          ${removable ? `
            <button class="remove-discount" data-code="${this.escapeHtml(code)}" aria-label="Remove ${this.escapeHtml(code)}" title="Remove">
              ${this.svgClose}
            </button>` : ``}
        </li>
      `;
    }).join('');
  }

  renderTotals(cart) {
    if (this.totalEls.length) {
      const total = this.money(cart.total_price || 0);
      this.totalEls.forEach(el => { el.textContent = total; });
    }
    const subtotalEl = document.querySelector('.totals__subtotal-value, [data-cart-subtotal]');
    if (subtotalEl && typeof cart.items_subtotal_price === 'number') {
      subtotalEl.textContent = this.money(cart.items_subtotal_price);
    }
    const totalDiscountEl = document.querySelector('[data-cart-total-discount], .totals__discount-value');
    if (totalDiscountEl && typeof cart.total_discount === 'number') {
      totalDiscountEl.textContent = cart.total_discount ? ('- ' + this.money(cart.total_discount)) : '';
    }
  }

  async refreshUI() {
    const cart = await this.cartGet();
    const { allCodes, codeCodes } = this.extractDiscountsFromCart(cart);
    this.renderBottomList(allCodes, codeCodes);
    this.renderTopDiscounts(cart);
    this.renderTotals(cart);
  }

  setLoading(isLoading, btnEl) {
    const btn = btnEl || document.querySelector('.custom-discount-form .submit-discount');
    const input = document.querySelector('.custom-discount-form input[name="custom-discount-input"]');
    if (!btn) return;

    if (isLoading) {
      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', 'true');
      btn.style.pointerEvents = 'none';
      if (input) input.disabled = true;

      let loader = btn.querySelector('.loader');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'loader';
        btn.appendChild(loader);
      }
      loader.style.display = 'block';
    } else {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
      btn.style.pointerEvents = '';
      if (input) input.disabled = false;

      const loader = btn.querySelector('.loader');
      if (loader) loader.style.display = 'none';
    }
  }

  showError(msg) {
    if (!this.errorEl) return;
    this.errorEl.style.display = 'block';
    this.errorEl.textContent = msg;
  }

  hideError() {
    if (!this.errorEl) return;
    this.errorEl.style.display = 'none';
    this.errorEl.textContent = '';
  }
}

(() => { new CartDiscounts(); })();